var map = {
	"./step10.png": "S97X",
	"./step11.png": "CJb9",
	"./step20.png": "kyhv",
	"./step21.png": "yJy2",
	"./step30.png": "eXem",
	"./step31.png": "LukZ",
	"./step40.png": "W8uM",
	"./step41.png": "4h2S",
	"./step50.png": "NI4s",
	"./step51.png": "Vetw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3tan";


//////////////////
// WEBPACK FOOTER
// ./src/assets/codeTraceability ^\.\/step.*\.png$
// module id = 3tan
// module chunks = 0